import React from 'react';
import { Chip } from '@mui/material';
import { Gavel as GavelIcon } from '@mui/icons-material';

/**
 * Beside the name of somebody who moderates the city the page is about.
 *
 * The API decides who gets it (`author_is_moderator`, `organizer_is_moderator`)
 * and gives it only to a moderator of *this* city: somebody who moderates the
 * next town has no more say here than any resident, and a badge would suggest
 * otherwise. This component only draws it.
 */
function ModeratorBadge({ show }) {
  if (!show) {
    return null;
  }

  return (
    <Chip
      icon={<GavelIcon />}
      label="Modérateur"
      size="small"
      color="success"
      variant="outlined"
      title="Modère les contenus de la ville"
      sx={{
        ml: 0.75,
        mr: 0.5,
        height: 24,
        px: 0.5,
        fontSize: '0.71875rem',
        verticalAlign: 'middle',
        '& .MuiChip-icon': { fontSize: 13, ml: 0.5 },
        '& .MuiChip-label': { px: 0.875 },
      }}
    />
  );
}

export default ModeratorBadge;
